import { absolutePath } from "../../absolutePath";

export const affiliate = {
  show: (communityMemberId: number) =>
    absolutePath(`paywalls/community_members/${communityMemberId}/affiliate`),
  enroll: (communityMemberId: number) =>
    absolutePath(
      `paywalls/community_members/${communityMemberId}/affiliate/enroll`,
    ),
  payoutEmail: (communityMemberId: number) =>
    absolutePath(
      `paywalls/community_members/${communityMemberId}/affiliate/payout_email`,
    ),
  commissions: {
    index: (
      communityMemberId: number,
      params: { [key: string]: string | number | object },
    ) =>
      absolutePath(
        `paywalls/community_members/${communityMemberId}/affiliate/commissions`,
        params,
      ),
  },
};
